import React, { useState } from "react";
import Nav from "../Nav/Nav";
import dandalsPolaroid from "../../images/DandalsJune2025.png";
import "./Contact.css";

const Modal = ({ show, onClose, imgSrc, alt }) => {
  if (!show) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <span className="modal-close" onClick={onClose}>
        &times;
      </span>
      <img
        className="modal-img"
        src={imgSrc}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

const Contact = (props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <React.Fragment>
      <Nav />
      <div className="live-container">
        <div className="live-picture">
          <img
            className="dandals-polaroid"
            src={dandalsPolaroid}
            alt="dandals 2025 group"
            style={{ cursor: "pointer" }}
            onClick={() => setShowModal(true)}
          />
        </div>
        <div className="contact-container">
          <div className="contact-details">Steve Klein: 612-269-9426</div>
          <div className="contact-details">Email: therealdandals@gmail.com</div>
        </div>
      </div>
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        imgSrc={dandalsPolaroid}
        alt="dandals 2025 group enlarged"
      />
    </React.Fragment>
  );
};

export default Contact;
